import styled from "styled-components";

export const Container = styled.div`
    max-width: 1488px;
    padding: 0 24px;
    margin: 85px auto 64px;

    h1 {
    font-size: var(--text-size-md);
    line-height: 28px;
    margin-top: 40px;
}

@media screen and (min-width: 1105px) {
    margin-bottom: 144px;

    h1 {
        line-height: 52px;
        font-size: var(--text-size-xlg);
        margin-top: 80px;
    }
}
`

export const Breadcrumbs = styled.div`
    padding-top: 40px;
    display: flex;
    align-items: center;

    span {
        font-size: var(--text-size-3xs);
        margin: 0 8px;
        color: var(--color-gray-500);
    }

    a {
        font-size: var(--text-size-3xs);
        color: var(--color-gray-500);

        &:last-child {
            color: var(--color-black);
        }
    }
`

export const Contents = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  margin-top: 40px;
  align-items: flex-start;

`;